// Generated by purs version 0.15.16
import * as Ran from "../Ran/index.js";
var pure = /* #__PURE__ */ Ran.pure(function (x) {
    return x;
});
var map = Ran.map;
var lower$prime = function (dictApplicative) {
    return Ran["lower$prime"](dictApplicative);
};
var lower = Ran.lower;
var liftEffect = function (dictMonadEffect) {
    return Ran.liftEffect(dictMonadEffect)(function (x) {
        return x;
    });
};
var liftAff = function (dictMonadAff) {
    return Ran.liftAff(dictMonadAff)(function (x) {
        return x;
    });
};
var lift$prime = function (dictComonad) {
    return Ran["lift$prime"](dictComonad)((dictComonad.Extend0()).Functor0());
};
var lift = function (dictFunctor) {
    return Ran.lift(dictFunctor);
};
var bind = /* #__PURE__ */ Ran.bind(function (x) {
    return x;
});
var apply = /* #__PURE__ */ Ran.apply(function (x) {
    return x;
});
export {
    apply,
    bind,
    lift,
    lift$prime,
    liftAff,
    liftEffect,
    lower,
    lower$prime,
    map,
    pure
};
//# sourceMappingURL=index.js.map
